import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MedicalPrescriptionService } from 'src/app/shared/services/API/medical-record/medical-prescription.service';
import { CallEpisodePrescriptionService } from 'src/app/shared/services/API/orchestrator-patient/call-episode-prescription.service';
import { LocationService } from 'src/app/shared/services/API/pharmacy/location.service';
import { MedicinePresentationTypeService } from 'src/app/shared/services/API/pharmacy/medicine-presentation-type.service';
import { PrescriptionNonDispensationService } from 'src/app/shared/services/API/pharmacy/prescription-non-dispensation.service';
import { VerifyStorageService } from 'src/app/shared/services/API/pharmacy/verify-storage.service';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { PrescriptionNonDispensationRequest } from 'src/app/shared/services/requests/medical-record/prescription-non-dispensation.request';
import { LiberateSolutionPrescriptionRequest } from 'src/app/shared/services/requests/orchestrator-patient/liberate-solution-prescription.request';
import { SolutionNonDispesationRequest } from 'src/app/shared/services/requests/pharmacy/solution-non-dispesation.request';
import { PrescriptionSolutionMedicineStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution-medicine.struct';
import { PrescriptionSolutionStruct } from 'src/app/shared/services/structs/pharmacy/prescription-solution.struct';

@Component({
    selector: 'app-prescription-solution-non-dispensation-all-modal',
    templateUrl: './prescription-solution-non-dispensation-all-modal.component.html',
    styleUrls: ['./prescription-solution-non-dispensation-all-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrescriptionSolutionNonDispensationAllModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public matDialogRef: MatDialogRef<PrescriptionSolutionNonDispensationAllModalComponent>,
    public verifyStorageService: VerifyStorageService,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    public locationService: LocationService,
    public callEpisodePrescriptionService: CallEpisodePrescriptionService,
    public medicinePresentationTypeService: MedicinePresentationTypeService,
    private prescriptionNonDispensationService: PrescriptionNonDispensationService
  ) { this.matDialogRef.disableClose = true; }

  public model: FormGroup;
  public listSolutionMedicine: PrescriptionSolutionMedicineStruct[] = [];

  public isLoading: boolean;

  public idPrescriptionSolution: number;

  ngOnInit(): void {
    this.isLoading = true;
    this.listSolutionMedicine = this.data.solution;
    this.idPrescriptionSolution = this.data.idPrescriptionSolution;

    this.model = this.formBuilder.group({
      patientName: [{ value: this.data.patientName, disabled: true }],
      nonDispensationReason: ['', [Validators.required]],
    });

    this.isLoading = false;
  }

  submit() {
    if (this.isLoading)
      return;

    if(this.model.invalid) {
      this.alertService.show('Erro', 'Você precisa informar todos os campos obrigatórios', AlertType.error);
      return;
    }
    
    let solutionNonDispesationRequest: SolutionNonDispesationRequest = new SolutionNonDispesationRequest();
    solutionNonDispesationRequest.idPrescriptionSolution = this.idPrescriptionSolution;
    
    this.listSolutionMedicine.forEach(x => {
      if (x) {
        let prescriptionNonDispensationRequest: PrescriptionNonDispensationRequest = new PrescriptionNonDispensationRequest();
        prescriptionNonDispensationRequest.idPrescriptionSolutionMedicine = x.prescriptionSolutionMedicine.idPrescriptionSolutionMedicine;
        prescriptionNonDispensationRequest.nonDispensationReason = this.model?.get('nonDispensationReason')?.value || '';
        solutionNonDispesationRequest.listPrescriptionNonDispensationRequest.push(prescriptionNonDispensationRequest);
      }
    });

    this.isLoading = true;
    this.prescriptionNonDispensationService.nonDispensationSolution(solutionNonDispesationRequest).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.isLoading = false;
        this.alertService.show('Sucesso', "Prescrição não dispensada!", AlertType.success);
        this.matDialogRef.close({ notDispensed: true });
      },
      error: (error) => {
        console.log(error)
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  clickCancel() {
    this.matDialogRef.close({ notDispensed: false });
  }
}
